import { memo } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { TableColumnConfig } from '@frontend/design-system';
import { Deductible, Maximum } from '../../../types/insurance-report-api.types';
import { Table } from '../common-components/table';

type MaxAndDeductibleProps = {
  maximum: Maximum[];
  deductible: Deductible[];
  colConfig: TableColumnConfig<Maximum>[];
};

export const MaxAndDeductible = memo(({ maximum, deductible, colConfig }: MaxAndDeductibleProps) => {
  const { t } = useTranslation('insurance-eligibility-report');

  return (
    <div css={maxAndDeductibleStyles}>
      {maximum?.length > 0 && (
        <div css={tableStyles}>
          <Table tableHeader={t('Maximums')} data={maximum} colConfig={colConfig} />
        </div>
      )}
      {deductible?.length > 0 && (
        <div css={tableStyles}>
          <Table tableHeader={t('Deductibles')} data={deductible} colConfig={colConfig} />
        </div>
      )}
    </div>
  );
});

MaxAndDeductible.displayName = 'MaxAndDeductible';

const maxAndDeductibleStyles = css`
  display: flex;
  flex-direction: row;
  gap: ${theme.spacing(2)};
`;
const tableStyles = css`
  flex: 1;
  border: 1px solid ${theme.colors.neutral20};
  border-radius: ${theme.borderRadius.medium};
`;
